import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "example-component border p-3" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "mb-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h2", null, [
      _createTextVNode("This is an "),
      _createElementVNode("strong", null, "example Vue component"),
      _createTextVNode(".")
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, "My prop \"message\" value is: " + _toDisplayString($props.message), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "My slot \"content\" is:", -1 /* CACHED */)),
      _renderSlot(_ctx.$slots, "content", {}, () => [
        _cache[1] || (_cache[1] = _createTextVNode(" Default content slot value ", -1 /* CACHED */))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "Clicking this button increments the data value \"count\"", -1 /* CACHED */)),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.incrementCount && $options.incrementCount(...args)))
      }, "Click me"),
      _createElementVNode("p", null, "Button click count: " + _toDisplayString($data.count), 1 /* TEXT */)
    ])
  ]))
}